import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Introduction"
                    description="HP Tech Solutions is a provider of comprehensive software development and cybersecurity services, including AI, web and mobile application development, and advanced security solutions. These Terms and Conditions apply to all services provided by us and any interactions with our website. If you do not agree to these terms, please refrain from using our services or accessing our website."/>
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Data Protection"
                    description="We take the security of your data seriously and will ensure that it is processed in accordance with applicable data protection regulations. However, as a user, you are also responsible for safeguarding sensitive data and preventing unauthorized access to your accounts."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Payment Terms"
                    description="Fees and Charges: You agree to pay for all services provided by HP Tech Solutions according to the pricing outlined in the service agreement.
Payment Method: Payments can be made using the methods specified during the service ordering process.
Late Payments: Late payments may incur additional charges as specified in your agreement."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Service Availability"
                    description="We strive to provide reliable and uninterrupted services. However, we do not guarantee that the services will always be available without interruption or errors, especially due to factors beyond our control (such as technical issues or third-party outages)."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Limitation of Liability"
                    description="HP Tech Solutions will not be liable for any indirect, incidental, special, or consequential damages resulting from the use of our services, including but not limited to data loss, loss of business profits, or damage to reputation, even if we have been advised of the possibility of such damages."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Confidentiality"
                    description="Both parties agree to maintain the confidentiality of any proprietary information disclosed during the course of service delivery. This includes business plans, software, systems, or any other confidential data shared between the parties."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Limitation of Liability"
                    description="HP Tech Solutions will not be liable for any indirect, incidental, special, or consequential damages resulting from the use of our services, including but not limited to data loss, loss of business profits, or damage to reputation, even if we have been advised of the possibility of such damages."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Intellectual Property"
                    description="Ownership: All intellectual property created during the course of the service (including software, designs, and documentation) remains the property of HP Tech Solutions unless otherwise agreed in writing.
Licensing: Any software or materials provided to you are licensed for use in accordance with the terms specified in the service agreement."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Termination of Services"
                    description="HP Tech Solutions reserves the right to suspend or terminate services if the user violates these Terms and Conditions or engages in activities that could harm the integrity of our systems or services."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Governing Law"
                    description="These Terms and Conditions are governed by the laws of the jurisdiction in which HP Tech Solutions is registered. Any disputes arising out of or relating to these terms will be resolved in the courts of that jurisdiction."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Modifications to Terms"
                    description="HP Tech Solutions reserves the right to modify or update these Terms and Conditions at any time. Any changes will be posted on this page, and continued use of our services constitutes acceptance of the modified terms."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
